import { Popover } from 'antd';
import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../hooks/useMainContext';
import { ButtonMode } from '../../config';
import Content from './Content';

const ClosetButton = observer(() => {
    const { viewManager, closetManager, drawingManager } = useMainContext();

    const isDisabled = !viewManager.doUserHasAccess();

    return (
        <Popover
            content={<Content />}
            title={null}
            trigger="click"
            arrow={true}
            className="custom-popover"
            popupStyle={{ zIndex: 99 }}
            styles={{
                body: {
                    width: '100vw',
                    transition: 'none',
                    animation: 'none',
                },
            }}
            transitionName=""
            open={viewManager.buttonMode !== ButtonMode.Unit}>
            <button
                disabled={isDisabled}
                onClick={() => {
                    if (isDisabled) return;
                    viewManager.setButtonMode(ButtonMode.Closet);
                    closetManager.setEditMode();
                    if (drawingManager.isDrawingModeOn) {
                        drawingManager.setDrawingMode(false);
                        drawingManager.stopDrawing();
                    }
                    if (drawingManager.isRectangleModeOn) {
                        drawingManager.setRectangleMode(false);
                    }
                    closetManager.setDistanceLabel(true);
                    closetManager.drawNewClosets();
                }}
                className={`h-[32px] w-[100px] border-[1px] border-theme-button-bg p-[4px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal transition-all duration-300 ease-in-out ${
                    isDisabled
                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed border-gray-300'
                        : 'bg-theme-button-bg text-[#000000] hover:bg-theme-orange-hover hover:text-white'
                } ${viewManager.buttonMode === ButtonMode.Closet ? 'active' : ''}`}>
                Closet
            </button>
        </Popover>
    );
});
export default ClosetButton;
